<p-toast></p-toast>

<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{lbl_loading}}</span>
</div>



<div class="card">
    <!-- GO BACK -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <p-tabView>
        <p-tabPanel header="Coordinación Zona" [selected]="true">
            <ng-template pTemplate="content">
                <!-- Main Card -->
                <div class="card" [formGroup]="coordinationForm">
                    <!-- Grid -->
                    <div class="p-grid">
                        <!-- 1st Section -->
                        <div class="p-col-12 p-md-6">
                            <div class="p-fluid">
                                <!-- Zona -->
                                <div class="p-col-12">
                                    <label for="coordination_catalog_zone">Zona
                                    </label>
                                    <input id="coordination_catalog_zone" type="text" pInputText
                                        formControlName="coordination_catalog_zone" />
                                </div>

                                <!-- Nombre Corto -->
                                <div class="p-col-12">
                                    <label for="coordination_catalog_shortname">Nombre Corto
                                        <span style="color: red;"
                                            *ngIf="coordinationForm.get('coordination_catalog_shortname').value == ''">
                                            (*)</span></label>
                                    <input id="coordination_catalog_shortname" type="text" pInputText
                                        formControlName="coordination_catalog_shortname" />
                                    <div *ngIf="coordinationForm.get('coordination_catalog_shortname').hasError('required') && coordinationForm.get('coordination_catalog_shortname').touched"
                                        class="error-message">Nombre Corto es requerido.</div>
                                </div>

                                <!-- Fecha Inicio -->
                                <div class="p-col-12">
                                    <label for="coordination_catalog_startdate">Fecha Inicio
                                        <span style="color: red;"
                                            *ngIf="coordinationForm.get('coordination_catalog_startdate').value == null">
                                            (*)</span></label>
                                    <p-calendar formControlName="coordination_catalog_startdate" [touchUI]="true"
                                        [readonlyInput]="true" inputId="touchui" dateFormat="yy-mm-dd"></p-calendar>
                                </div>

                                <!-- Inventario -->
                                <div class="p-col-12"
                                    style="display: flex; justify-content: space-between; padding-right: 10%;">
                                    <label for="coordination_catalog_inventory">Tiene inventario Fisico/Virtual?
                                    </label>
                                    <div class="p-field-radiobutton">
                                        <p-radioButton [value]="true" id="coordination_catalog_inventory1"
                                            formControlName="coordination_catalog_inventory"></p-radioButton>
                                        <label for="coordination_catalog_inventory1">Sí</label>
                                    </div>
                                    <div class="p-field-radiobutton">
                                        <p-radioButton [value]="false" id="coordination_catalog_inventory2"
                                            formControlName="coordination_catalog_inventory"></p-radioButton>
                                        <label for="coordination_catalog_inventory2">No</label>
                                    </div>
                                </div>

                                <!-- Principal Dirección -->
                                <div class="p-col-12">
                                    <label for="coordination_catalog_adr">Principal Dirección</label>
                                    <p-dropdown id="coordination_catalog_adr" [options]="addressLst"
                                        formControlName="coordination_catalog_adr"
                                        placeholder="Seleccione una dirección" optionLabel="label"
                                        [showClear]="true"></p-dropdown>
                                </div>
                            </div>
                        </div>

                        <!-- 2nd Section -->
                        <div class="p-col-12 p-md-6">
                            <div class="p-fluid">
                                <!-- Dirección Bodega -->
                                <div class="p-col-12">
                                    <label for="coordination_catalog_adrB">Dirección Bodega</label>
                                    <p-dropdown id="coordination_catalog_adrB" [options]="addressLst"
                                        formControlName="coordination_catalog_adrB"
                                        placeholder="Seleccione una dirección" optionLabel="label"
                                        [showClear]="true"></p-dropdown>
                                </div>

                                <!-- Pais -->
                                <div class="p-col-12">
                                    <label for="coordination_catalog_country">País Solicitudes a proveedores</label>
                                    <p-dropdown id="coordination_catalog_country" [options]="addressLst"
                                        formControlName="coordination_catalog_country" placeholder="Seleccione un país"
                                        optionLabel="value" [showClear]="label"></p-dropdown>
                                </div>

                                <!-- Email Coordinador -->
                                <div class="p-col-12">
                                    <label for="coordination_catalog_emailCord">Email Coordinador(Institu.)</label>
                                    <input id="coordination_catalog_emailCord" type="text" pInputText
                                        formControlName="coordination_catalog_emailCord" />
                                </div>

                                <!-- Email Secretario -->
                                <div class="p-col-12">
                                    <label for="coordination_catalog_emailSecre">Email Secretario(Institu.)</label>
                                    <input id="coordination_catalog_emailSecre" type="text" pInputText
                                        formControlName="coordination_catalog_emailSecre" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Botones -->
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6"></div>
                        <div class="p-col-12 p-md-6">
                            <!-- Buttons -->
                            <div class="p-col-12">
                                <div class=" p-fluid p-formgrid p-grid church_field">
                                    <div class="p-col-12 p-md-4"></div>
                                    <div class="p-col-12 p-md-4">
                                        <div class="p-field">
                                            <button pButton pRipple type="button" icon="pi pi-plus" label="Guardar"
                                                class="p-button-raised p-button-success"
                                                (click)="saveUpdateCoordinationDtl($event,'S')"></button>

                                        </div>
                                    </div>
                                    <div class="p-col-12 p-md-4">
                                        <div class="p-field">
                                            <button pButton pRipple type="button" icon="pi pi-trash" label="Eliminar"
                                                class="p-mr-2 p-mb-2 p-button-raised p-button-danger"
                                                (click)="deleteCoordinationDtl($event)"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Equipos Zonales">
            <ng-template pTemplate="content">
                <p-table #dt [value]="coordinationCatalogList" [exportFilename]="tableName"
                    [columns]="[{ field: 'coordName', header: 'Coordinación' },{ field: 'levelId', header: 'Tipo' },{ field: 'coord.guideName', header: 'Coordinador' }
            ,{ field: 'secre.guideName', header: 'Secretario' },{ field: 'treas.guideName', header: 'Tesorero' },{ field: 'mater.guideName', header: 'Encargado De Materiales' }
            ,{ field: 'young.guideName', header: 'Guía Jovenes' },{ field: 'sfg.guideName', header: 'Encargado de Escuelas' }]" [rows]="10" [paginator]="true"
                    [globalFilterFields]="['coordName','levelId','coord.guideName','secre.guideName','treas.guideName','mater.guideName','young.guideName','sfg.guideName']"
                    [(selection)]="selectedCoordinationCatalog" selectionMode="multiple" [rowHover]="true"
                    dataKey="storeId"
                    currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
                    [showCurrentPageReport]="true" responsive="true">

                    <!-- CAPTION -->
                    <ng-template pTemplate="caption">
                        <span class="p-input-icon-left">
                            <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                                class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                                class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-filter"
                                (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto  p-mr-2"
                                pTooltip="Selection Only" tooltipPosition="bottom"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-mr-2 z-5"
                                (click)="loadCoordinationCatalogs()"></button>
                        </span>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <!-- Order -->
                        <tr>
                            <th pSortableColumn="coordName">{{lbl_coordination}}<p-sortIcon
                                    field="coordName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="levelId">{{lbl_type}}<p-sortIcon field="levelId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="coord.guideName">{{lbl_coordinator}}<p-sortIcon
                                    field="coord.guideName"></p-sortIcon></th>
                            <th pSortableColumn="secre.guideName">{{lbl_secretary}}<p-sortIcon
                                    field="secre.guideName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="treas.guideName">{{lbl_treasurer}}<p-sortIcon
                                    field="treas.guideName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="mater.guideName">{{lbl_material_man}}<p-sortIcon
                                    field="mater.guideName"></p-sortIcon></th>
                            <th pSortableColumn="young.guideName">{{lbl_Guide}} {{lbl_youngs}} <p-sortIcon
                                    field="young.guideName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="sfg.guideName">{{lbl_school_prep_guides_charge}}<p-sortIcon
                                    field="sfg.guideName"></p-sortIcon>
                            </th>
                            <th></th>
                        </tr>
                        <!-- Filter -->
                        <tr>
                            <th>
                                <p-columnFilter type="text" field="coordName"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" field="levelId"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" field="coord.guideName"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" field="secre.guideName"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" field="treas.guideName"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" field="mater.guideName"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" field="young.guideName"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" field="sfg.guideName"></p-columnFilter>
                            </th>
                            <th> </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-item>
                        <tr [pSelectableRow]="item">
                            <td>{{item?.coordName ? item?.coordName : 'S/N'}}</td>
                            <td>{{item?.levelId ? item?.levelId : 'S/N'}}</td>

                            <!-- COORD -->
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; justify-content: center; align-items: start;">

                                    <div class="coordName">
                                        <!-- <span>Nombre: </span> -->
                                        <span style="font-weight: bold;"
                                            class="coordName-nowrap">{{item?.coord?.guideName}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.coord?.email1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.coord?.email2}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!-- <span>Telefono: </span> -->
                                        <span class="coordName-nowrap">{{item?.coord?.tel1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Movíl: </span> -->
                                        <span class="coordName-nowrap">{{item?.coord?.mobile}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Ciudad: </span> -->
                                        <span class="coordName-nowrap">{{item?.coord?.cityStateCountry}}</span>
                                    </div>

                                </div>
                            </td>

                            <!-- SECRE -->
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; justify-content: center; align-items: start;">

                                    <div class="coordName">
                                        <!-- <span>Nombre: </span> -->
                                        <span style="font-weight: bold;"
                                            class="coordName-nowrap">{{item?.secre?.guideName}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.secre?.email1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.secre?.email2}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!-- <span>Telefono: </span> -->
                                        <span class="coordName-nowrap">{{item?.secre?.tel1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Movíl: </span> -->
                                        <span class="coordName-nowrap">{{item?.secre?.mobile}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Ciudad: </span> -->
                                        <span class="coordName-nowrap">{{item?.secre?.cityStateCountry}}</span>
                                    </div>

                                </div>
                            </td>

                            <!-- TREAS -->
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; justify-content: center; align-items: start;">

                                    <div class="coordName">
                                        <!-- <span>Nombre: </span> -->
                                        <span style="font-weight: bold;"
                                            class="coordName-nowrap">{{item?.treas?.guideName}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.treas?.email1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.treas?.email2}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!-- <span>Telefono: </span> -->
                                        <span class="coordName-nowrap">{{item?.treas?.tel1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Movíl: </span> -->
                                        <span class="coordName-nowrap">{{item?.treas?.mobile}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Ciudad: </span> -->
                                        <span class="coordName-nowrap">{{item?.treas?.cityStateCountry}}</span>
                                    </div>

                                </div>
                            </td>

                            <!-- MATER -->
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; justify-content: center; align-items: start;">

                                    <div class="coordName">
                                        <!-- <span>Nombre: </span> -->
                                        <span style="font-weight: bold;"
                                            class="coordName-nowrap">{{item?.mater?.guideName}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.mater?.email1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.mater?.email2}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!-- <span>Telefono: </span> -->
                                        <span class="coordName-nowrap">{{item?.mater?.tel1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Movíl: </span> -->
                                        <span class="coordName-nowrap">{{item?.mater?.mobile}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Ciudad: </span> -->
                                        <span class="coordName-nowrap">{{item?.mater?.cityStateCountry}}</span>
                                    </div>

                                </div>
                            </td>

                            <!-- YOUNG -->
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; justify-content: center; align-items: start;">

                                    <div class="coordName">
                                        <!-- <span>Nombre: </span> -->
                                        <span style="font-weight: bold;"
                                            class="coordName-nowrap">{{item?.young?.guideName}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.young?.email1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.young?.email2}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!-- <span>Telefono: </span> -->
                                        <span class="coordName-nowrap">{{item?.young?.tel1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Movíl: </span> -->
                                        <span class="coordName-nowrap">{{item?.young?.mobile}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Ciudad: </span> -->
                                        <span class="coordName-nowrap">{{item?.young?.cityStateCountry}}</span>
                                    </div>

                                </div>
                            </td>

                            <!-- SFG -->
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; justify-content: center; align-items: start;">

                                    <div class="coordName">
                                        <!-- <span>Nombre: </span> -->
                                        <span style="font-weight: bold;"
                                            class="coordName-nowrap">{{item?.sfg?.guideName}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.sfg?.email1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Email: </span> -->
                                        <span class="coordName-nowrap">{{item?.sfg?.email2}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!-- <span>Telefono: </span> -->
                                        <span class="coordName-nowrap">{{item?.sfg?.tel1}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Movíl: </span> -->
                                        <span class="coordName-nowrap">{{item?.sfg?.mobile}}</span>
                                    </div>

                                    <div class="coordName">
                                        <!--  <span>Ciudad: </span> -->
                                        <span class="coordName-nowrap">{{item?.sfg?.cityStateCountry}}</span>
                                    </div>

                                </div>
                            </td>

                            <td>
                                <button pButton pRipple icon="pi pi-pencil"
                                    class="p-button-rounded p-button-warning p-mr-2"
                                    (click)="editCoordinationCatalog(item)"></button>
                                <button pButton *ngIf="renderButtons" pRipple icon="pi pi-trash"
                                    class="p-button-rounded p-button-warning"
                                    (click)="deleteCoordinationCatalog(item)"></button>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="summary">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            {{lbl_total}} {{coordinationCatalogList ? coordinationCatalogList.length : 0 }}
                            {{lbl_records}}
                        </div>
                    </ng-template>


                </p-table>
            </ng-template>
        </p-tabPanel>
    </p-tabView>

</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>